var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-card",
        {
          attrs: {
            elevation: "0",
          },
        },
        [
          _c(
            "v-card-title",
            {
              staticClass: "d-flex align-content-end flex-wrap align-items-end",
            },
            [
              _c(
                "v-container",
                {
                  attrs: {
                    fluid: "",
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            lg: "6",
                          },
                        },
                        [
                          _c(
                            "v-menu",
                            {
                              ref: "showDateDialog",
                              attrs: {
                                "close-on-content-click": false,
                                "return-value": _vm.query.dateRange,
                                transition: "scale-transition",
                                "offset-y": "",
                              },
                              on: {
                                "update:returnValue": function ($event) {
                                  return _vm.$set(
                                    _vm.query,
                                    "dateRange",
                                    $event
                                  )
                                },
                                "update:return-value": function ($event) {
                                  return _vm.$set(
                                    _vm.query,
                                    "dateRange",
                                    $event
                                  )
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function (_ref) {
                                    var on = _ref.on,
                                      attrs = _ref.attrs
                                    return [
                                      _c(
                                        "v-text-field",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "ช่วงวันที่",
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: _vm.dateRangeText,
                                                callback: function ($$v) {
                                                  _vm.dateRangeText = $$v
                                                },
                                                expression: "dateRangeText",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.showDateDialog,
                                callback: function ($$v) {
                                  _vm.showDateDialog = $$v
                                },
                                expression: "showDateDialog",
                              },
                            },
                            [
                              _vm._v(" "),
                              _vm.showDateDialog
                                ? _c(
                                    "v-date-picker",
                                    {
                                      attrs: {
                                        range: "",
                                        width: "320",
                                        max: _vm.$moment().format("YYYY-MM-DD"),
                                      },
                                      model: {
                                        value: _vm.query.dateRange,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.query, "dateRange", $$v)
                                        },
                                        expression: "query.dateRange",
                                      },
                                    },
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: "",
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.showDateDialog = false
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Cancel\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$refs.showDateDialog.save(
                                                _vm.query.dateRange
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  OK\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            lg: "6",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-items-baseline my-2",
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "mx-3",
                                attrs: {
                                  "prepend-icon": "mdi-magnify",
                                  autocomplete: "off",
                                  "hide-details": "",
                                  label: "ค้นหา",
                                  clearable: "",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.query.text = $event
                                  },
                                },
                                model: {
                                  value: _vm.query.text,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, "text", $$v)
                                  },
                                  expression: "query.text",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                  },
                                  on: {
                                    click: _vm.fetchData,
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                      },
                                    },
                                    [_vm._v(" mdi-check ")]
                                  ),
                                  _vm._v(
                                    "\n                ค้นหา\n              "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    color: "secondary",
                                    outlined: "",
                                  },
                                  on: {
                                    click: _vm.resetFilter,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                ล้าง\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-flex align-items-start flex-column flex-lg-row",
                        },
                        [
                          _c(
                            "v-btn-toggle",
                            {
                              staticClass: "mr-4 my-2",
                              attrs: {
                                multiple: "",
                                mandatory: "",
                                dense: "",
                              },
                              on: {
                                change: _vm.fetchData,
                              },
                              model: {
                                value: _vm.query.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "type", $$v)
                                },
                                expression: "query.type",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    value: "debit",
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                      },
                                    },
                                    [_vm._v(" mdi-arrow-left ")]
                                  ),
                                  _vm._v("ฝาก\n              "),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    value: "credit",
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        left: "",
                                      },
                                    },
                                    [_vm._v(" mdi-arrow-right ")]
                                  ),
                                  _vm._v("ถอน\n              "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn-toggle",
                            {
                              staticClass: "my-2",
                              attrs: {
                                multiple: "",
                                mandatory: "",
                                dense: "",
                              },
                              on: {
                                change: _vm.fetchData,
                              },
                              model: {
                                value: _vm.query.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "status", $$v)
                                },
                                expression: "query.status",
                              },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    value: "submitted",
                                  },
                                },
                                [_vm._v(" รอ ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    value: "approved",
                                  },
                                },
                                [_vm._v(" ยืนยันแล้ว ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    value: "rejected",
                                  },
                                },
                                [_vm._v(" ปฎิเสธแล้ว ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    value: "cancelled",
                                  },
                                },
                                [_vm._v(" ยกเลิก ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _c(
                          "div",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-sm d-block",
                              },
                              [_vm._v("ธนาคารของเอเจน")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn-toggle",
                              {
                                attrs: {
                                  multiple: "",
                                },
                                on: {
                                  change: _vm.fetchData,
                                },
                                model: {
                                  value: _vm.query.banks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, "banks", $$v)
                                  },
                                  expression: "query.banks",
                                },
                              },
                              _vm._l(_vm.agentBanks, function (bank) {
                                return _c(
                                  "v-btn",
                                  {
                                    key: bank.id,
                                    attrs: {
                                      title: `${bank.account_name} - ${bank.account_number}`,
                                      value: bank.account_number,
                                    },
                                  },
                                  [
                                    _c("v-img", {
                                      attrs: {
                                        src: bank.logo_url,
                                        width: "25",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("p", {
                                      staticClass: "text-xs mb-0 text-left",
                                    }),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "span",
                              {
                                staticClass: "text-sm d-block",
                              },
                              [_vm._v("ธนาคารของยูสเซอร์")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn-toggle",
                              {
                                attrs: {
                                  multiple: "",
                                },
                                on: {
                                  change: _vm.fetchData,
                                },
                                model: {
                                  value: _vm.query.userBanks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.query, "userBanks", $$v)
                                  },
                                  expression: "query.userBanks",
                                },
                              },
                              _vm._l(
                                ["bay", "bbl", "ktb", "kbank", "tmb", "scb"],
                                function (bank) {
                                  return _c(
                                    "v-btn",
                                    {
                                      key: bank,
                                      attrs: {
                                        value: bank,
                                      },
                                    },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: `/bank/${bank}.svg`,
                                          width: "25",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        staticClass: "text-xs mb-0 text-left",
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex mr-3 flex-column flex-lg-row align-items-baseline",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "mr-2 d-inline-block text-sm mr-2",
                              },
                              [_vm._v("จำนวนเงิน")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-row space-between mr-2",
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "text-right text-monospace",
                                  staticStyle: {
                                    "max-width": "120px",
                                  },
                                  attrs: {
                                    type: "number",
                                    minimum: "0",
                                    clearable: "",
                                    label: "จาก",
                                    prefix: "฿",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.query.amountRange.minimum,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.query.amountRange,
                                        "minimum",
                                        $$v
                                      )
                                    },
                                    expression: "query.amountRange.minimum",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mx-2",
                                  },
                                  [_vm._v(" mdi-arrow-right ")]
                                ),
                                _vm._v(" "),
                                _c("v-text-field", {
                                  staticClass: "text-right text-monospace",
                                  staticStyle: {
                                    "max-width": "120px",
                                  },
                                  attrs: {
                                    type: "number",
                                    minimum: Math.max(
                                      0,
                                      _vm.query.amountRange.minimum
                                    ),
                                    clearable: "",
                                    label: "ถึง",
                                    prefix: "฿",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.query.amountRange.maximum,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.query.amountRange,
                                        "maximum",
                                        $$v
                                      )
                                    },
                                    expression: "query.amountRange.maximum",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex flex-row py-2",
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                    },
                                    on: {
                                      click: _vm.fetchData,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          left: "",
                                        },
                                      },
                                      [_vm._v(" mdi-check ")]
                                    ),
                                    _vm._v(
                                      "\n                  ค้นหา\n                "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      color: "secondary",
                                      outlined: "",
                                    },
                                    on: {
                                      click: _vm.resetFilter,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  ล้าง\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                [
                  _vm.newRequestCount > 0
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red",
                            outlined: "",
                          },
                          on: {
                            click: _vm.loadNewItem,
                          },
                        },
                        [
                          _vm._v("\n          มีรายการใหม่\n          "),
                          _c(
                            "v-chip",
                            {
                              staticClass: "ml-2",
                              attrs: {
                                right: "",
                                color: "red text-white",
                                "x-small": "",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.newRequestCount) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-0",
                attrs: {
                  "footer-props": _vm.footer,
                  headers: _vm.headers,
                  items: _vm.items,
                  loading: _vm.loading,
                  "multi-sort": false,
                  options: _vm.options,
                  search: _vm.search,
                  "server-items-length": _vm.totalItems,
                  "item-key": "id",
                  "item-class": _vm.rowClass,
                },
                on: {
                  "update:items": function ($event) {
                    _vm.items = $event
                  },
                  "update:options": function ($event) {
                    _vm.options = $event
                  },
                  "update:search": function ($event) {
                    _vm.search = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.submitted_at",
                    fn: function (_ref2) {
                      var item = _ref2.item
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "d-block",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm
                                    .$moment(
                                      item.submitted_at == null
                                        ? item.created_at
                                        : item.submitted_at
                                    )
                                    .format("YYYY-MM-DD HH:mm:ss")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-chip",
                          {
                            staticClass: "pa-1 m-0",
                            attrs: {
                              pill: "",
                              "x-small": "",
                              outlined:
                                item.status == "submitted" &&
                                _vm
                                  .$moment()
                                  .diff(
                                    _vm.$moment(
                                      item.submitted_at == null
                                        ? item.created_at
                                        : item.submitted_at
                                    ),
                                    "seconds"
                                  ) > 300,
                              color:
                                item.status == "submitted" &&
                                _vm
                                  .$moment()
                                  .diff(
                                    _vm.$moment(
                                      item.submitted_at == null
                                        ? item.created_at
                                        : item.submitted_at
                                    ),
                                    "seconds"
                                  ) > 300
                                  ? "red"
                                  : "light",
                            },
                          },
                          [
                            item.status == "submitted"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .$moment(
                                          item.submitted_at == null
                                            ? item.created_at
                                            : item.submitted_at
                                        )
                                        .fromNow()
                                    )
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm
                                        .$moment(
                                          item.submitted_at == null
                                            ? item.created_at
                                            : item.submitted_at
                                        )
                                        .from(item.updated_at)
                                    )
                                  ),
                                ]),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.transactioned_at",
                    fn: function (_ref3) {
                      var item = _ref3.item
                      return [
                        item.transactioned_at
                          ? _c(
                              "span",
                              {
                                staticClass: "d-block",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(item.transactioned_at)
                                      .format("YYYY-MM-DD HH:mm:ss")
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.user",
                    fn: function (_ref4) {
                      var item = _ref4.item
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: `/management/member/credit/${item.user.id}`,
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "my-1 d-block",
                              },
                              [_vm._v(" " + _vm._s(item.user.name))]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.bank",
                    fn: function (_ref5) {
                      var item = _ref5.item
                      return [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-row align-items-center mb-2",
                          },
                          [
                            _c("v-img", {
                              attrs: {
                                src: item.user.banks[0].logo_url,
                                "max-width": "25",
                                "max-height": "25",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "mb-0 ml-3 text-left",
                                staticStyle: {
                                  "font-size": "1em",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.user.banks[0].account_name)
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-monospace",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.user.banks[0].account_number)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.type",
                    fn: function (_ref6) {
                      var item = _ref6.item
                      return [
                        item.type == "debit"
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  color: "success",
                                  small: "",
                                  "text-color": "white",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      left: "",
                                      "x-small": "",
                                      "text-color": "white",
                                    },
                                  },
                                  [_vm._v(" mdi-arrow-right ")]
                                ),
                                _vm._v("\n            ฝาก\n          "),
                              ],
                              1
                            )
                          : _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  color: "red",
                                  "text-color": "white",
                                  small: "",
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      left: "",
                                      "x-small": "",
                                      "text-color": "white",
                                    },
                                  },
                                  [_vm._v(" mdi-arrow-left ")]
                                ),
                                _vm._v("ถอน\n          "),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                  {
                    key: "item.account_name",
                    fn: function (_ref7) {
                      var item = _ref7.item
                      return [
                        item.type == "debit"
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex align-items-center",
                              },
                              [
                                _c("v-img", {
                                  staticClass: "mx-auto",
                                  attrs: {
                                    src: `/bank/${item.bank}.svg`,
                                    contain: "",
                                    "max-height": "35",
                                    "max-width": "35",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "item.amount",
                    fn: function (_ref8) {
                      var item = _ref8.item
                      return [
                        item.type == "debit"
                          ? _c(
                              "span",
                              {
                                staticClass: "text-lg",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.amount.toLocaleString("en-US", {
                                      maximumFractionDigits: 2,
                                      minimumFractionDigits: 2,
                                    })
                                  ) + "\n            "
                                ),
                                item.status === "submitted"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.decimal_status[item.id],
                                              expression:
                                                "decimal_status[item.id]",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.decimal_status[item.id]
                                            )
                                              ? _vm._i(
                                                  _vm.decimal_status[item.id],
                                                  null
                                                ) > -1
                                              : _vm.decimal_status[item.id],
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.decimal_status[item.id],
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false

                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)

                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.decimal_status,
                                                      item.id,
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.decimal_status,
                                                      item.id,
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.decimal_status,
                                                  item.id,
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v("ปัดเศษ\n            "),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "text-lg",
                              },
                              [
                                _vm._v(
                                  _vm._s(item.amount.toLocaleString("en-US"))
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                  {
                    key: "item.status",
                    fn: function (_ref9) {
                      var item = _ref9.item
                      return [
                        item.approved_by === 1
                          ? _c(
                              "v-icon",
                              {
                                attrs: {
                                  small: "",
                                  color: "success",
                                },
                              },
                              [_vm._v("\n            mdi-auto-fix\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.status === "submitted"
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  label: "",
                                  small: "",
                                  color: "warning",
                                },
                              },
                              [_vm._v("\n            รอ\n          ")]
                            )
                          : item.status === "cancelled"
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  label: "",
                                  small: "",
                                  color: "grey",
                                  "text-color": "white",
                                },
                              },
                              [_vm._v("\n            ยกเลิก\n          ")]
                            )
                          : item.status === "approved"
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  label: "",
                                  small: "",
                                  color: "success",
                                },
                              },
                              [_vm._v("\n            ยืนยันแล้ว\n          ")]
                            )
                          : _c(
                              "v-chip",
                              {
                                staticClass: "ma-2",
                                attrs: {
                                  label: "",
                                  small: "",
                                  color: "red darken-4",
                                  "text-color": "white",
                                },
                              },
                              [_vm._v("\n            ปฎิเสธแล้ว\n          ")]
                            ),
                      ]
                    },
                  },
                  {
                    key: "item.comments",
                    fn: function (_ref10) {
                      var item = _ref10.item
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "d-inline-block text-truncate",
                            staticStyle: {
                              "max-width": "150px",
                            },
                          },
                          [_vm._v(_vm._s(item.remark) + "\n          ")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.manage",
                    fn: function (_ref11) {
                      var item = _ref11.item
                      return [
                        _c("div", [
                          _c(
                            "span",
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openComment(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color:
                                          item.comments.length > 0 &&
                                          item.comments[0].message != null
                                            ? "success"
                                            : "",
                                      },
                                    },
                                    [_vm._v("mdi-comment-text")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        item.status === "submitted"
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex",
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      txnid: item.id,
                                      status: "approved",
                                    },
                                    on: {
                                      click: _vm.updateStatus,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              ยืนยัน\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mx-3",
                                    attrs: {
                                      color: "red",
                                      outlined: "",
                                      txnid: item.id,
                                      status: "rejected",
                                    },
                                    on: {
                                      click: _vm.updateStatus,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              ปฎิเสธ\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item.status === "approved"
                          ? _c(
                              "div",
                              [
                                _c("button-hold-to-confirm", {
                                  attrs: {
                                    color: "red",
                                    label: "ยกเลิกรายการ",
                                  },
                                  on: {
                                    confirmed: function ($event) {
                                      return _vm.cancelTransaction(item.id)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "500",
            "max-width": "100vw",
            persistent: "",
          },
          model: {
            value: _vm.commentItem,
            callback: function ($$v) {
              _vm.commentItem = $$v
            },
            expression: "commentItem",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  attrs: {
                    dark: "",
                    color: "red darken-1",
                  },
                },
                [
                  _c("v-card-title", [
                    _c(
                      "span",
                      {
                        staticClass: "text-body-1",
                      },
                      [_vm._v("โน๊ตของเอเจน")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            dark: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.closeComment()
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                {
                  staticClass: "mt-5",
                },
                [
                  _c(
                    "v-form",
                    {
                      ref: "commentForm",
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                              },
                            },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  solo: "",
                                  name: "commentDetail",
                                  value: _vm.commentDetail,
                                },
                                model: {
                                  value: _vm.commentDetail,
                                  callback: function ($$v) {
                                    _vm.commentDetail = $$v
                                  },
                                  expression: "commentDetail",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-4",
                          attrs: {
                            color: "success",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addComment()
                            },
                          },
                        },
                        [_vm._v("\n            บันทึก\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red darken-1",
                        text: "",
                        outlined: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.closeComment()
                        },
                      },
                    },
                    [_vm._v("\n          Close\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "290",
          },
          model: {
            value: _vm.dialogPreload,
            callback: function ($$v) {
              _vm.dialogPreload = $$v
            },
            expression: "dialogPreload",
          },
        },
        [
          _c(
            "v-card",
            {
              attrs: {
                color: "red",
                dark: "",
              },
            },
            [
              _c(
                "v-card-text",
                [
                  _vm._v("\n        กำลังประมวลผล\n        "),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: {
                      indeterminate: "",
                      color: "white",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }